import {useCallback} from 'react';
import type {FileItem} from '../../types/directory';

export function useFilePermission({
                                    currentUser,
                                    isMyFileLevel
                                  }: {
  currentUser: any;
  isMyFileLevel: boolean;
}) {
  const isOwner = useCallback((record: FileItem) => {
    return Number(record.owner_id) === Number(currentUser?.user_id);
  }, [currentUser]);

  const isAdmin = useCallback(() => {
    return !!currentUser?.is_admin;
  }, [currentUser]);

  const canManage = useCallback((record: FileItem) => {
    return isMyFileLevel || isOwner(record) || isAdmin();
  }, [isMyFileLevel, isOwner, isAdmin]);

  const canOperate = useCallback((record: FileItem) => {
    return canManage(record) || record.visibility === 'edit';
  }, [canManage]);

  const canUpdatePermission = useCallback((record: FileItem) => {
    return !isMyFileLevel && (isAdmin() || isOwner(record));
  }, [isMyFileLevel, isAdmin, isOwner]);

  return {
    isOwner,
    isAdmin,
    canManage,
    canOperate,
    canUpdatePermission
  };
}